module.exports = __webpack_public_path__ + "static/img/red.a633b7e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeimg/red.gif
// module id = CReT
// module chunks = 1